import { FC } from 'react';

import styled from 'styled-components';
import Button from '../../../atoms/Button';
import Text from '../../../atoms/Text';

import image from './woman-image.png';

interface CardProps {
  onClick?: () => void;
  imagePath?: string;
  title?: string;
  text?: string;
  subtitle?: string;
  actionText?: string;
  hasImage?: boolean;
}

const S = {
  Container: styled.div`
    background: #f0f0f0;
    border-radius: 16px;
    position: relative;
    margin: 0;
    width: 327px;
    height: 370px;
    overflow: hidden;
    margin-bottom: 18px;

    img {
      width: 100%;
      height: 150px;
      object-fit: cover;
    }

    .body {
      padding: 0 16px;
      margin: 18px 0;
    }

    .footer {
      padding: 0 16px;
    }
  `,
};

const Card: FC<CardProps> = ({ onClick, title, text, actionText, hasImage, imagePath }) => {
  return (
    <S.Container>
      <div className='head'>{hasImage && <img src={imagePath || image} alt={title} />}</div>

      <div className='body'>
        {title && (
          <Text fontSize='12px' color='#767676' lineHeight='14.52px' bold>
            {title}
          </Text>
        )}
        {text && (
          <Text fontSize='12px' color='#767676' lineHeight='14.52px'>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </Text>
        )}
      </div>

      {actionText && (
        <div className='footer'>
          <Button onClick={onClick} full>
            {actionText}
          </Button>
        </div>
      )}
    </S.Container>
  );
};

export default Card;
